export default [
  {
    type: 'activity',
    formItems: [
      {
        label: "标题",
        name: "title",
        defaultValue: '扫码有礼',
        key: "params",
        type: "text",
        stamp: 'input'
      },
      {
        label: "背景图",
        name: "backgroundImage",
        key: "style",
        defaultValue: '/web_base_assets/scan/join_default_bg.png',
        stamp: 'singleImage',
        help: "(建议尺寸750*1200，图片大小500KB以内,为确保消费者扫码体验，图片大小建议控制在300KB以内)"
      },
      {
        label: "背景颜色",
        name: "backgroundColor",
        key: "style",
        defaultValue: '#ff2419',
        type: "color",
        stamp: 'input'
      },
      {
        label: "按钮图片",
        name: "btnBackgroundImage",
        key: "style",
        defaultValue: '/web_base_assets/scan/join_default_btn.png',
        stamp: 'singleImage',
        help: "(建议尺寸672*256，图片大小500KB以内,为确保消费者扫码体验，图片大小建议控制在300KB以内)"
      },
      {
        label: "是否顶部会员中心显示",
        name: "is_show_user",
        type: "text",
        stamp: 'radio',
        key: "params",
        options: [
          { label: '开启', value: true },
          { label: '关闭', value: false },
        ],
      },
      {
        label: "是否显示导购入口",
        name: "is_show_guide",
        type: "text",
        stamp: 'radio',
        key: "params",
        options: [
          { label: '开启', value: true },
          { label: '关闭', value: false },
        ],
      },
    ]
  },
  {
    type: 'award',
    formItems: [
      {
        label: "背景图",
        name: "backgroundImage",
        key: "style",
        stamp: 'singleImage',
        defaultValue: '/web_base_assets/scan/award_bg_default.png',
        help: "推荐尺寸750*1200,图片大小500kb以内"
      },
      {
        label: "背景颜色",
        name: "backgroundColor",
        key: "style",
        defaultValue: '#FF9501',
        type: "color",
        stamp: 'input'
      },
      {
        label: "中奖标题字颜色",
        name: "titleColor",
        defaultValue: '#ff3600',
        key: "style",
        type: "color",
        stamp: 'input'
      },
      {
        label: "中奖文案字颜色",
        name: "textColor",
        defaultValue: '#E81425',
        key: "style",
        type: "color",
        stamp: 'input'
      },
      {
        label: "显示控制",
        name: "rankingKey",
        type: "text",
        stamp: 'checkbox',
        key: "params",
        help:'勾选需要显示的字段',
        options: [
          { label: '红包排行榜', value: 'red' },
          { label: '积分排行榜', value: 'point' },
        ],
      },
      {
        label: "显示控制",
        name: "btnKey",
        type: "text",
        stamp: 'checkbox',
        key: "params",
        help:'勾选需要显示的字段',
        options: [
          { label: '云店商城', value: 'cloud' },
          { label: '会员中心', value: 'center' },
        ],
      },
    ]
  },
  {
    type: 'write',
    formItems: [
      {
        label: "收货信息头部标题",
        name: "titleColor",
        defaultValue: '#121212',
        key: "style",
        type: "color",
        stamp: 'input'
      },
      {
        label: "收货信息标题颜色",
        name: "labelColor",
        defaultValue: '#121212',
        key: "style",
        type: "color",
        stamp: 'input'
      },
    ]

  },
  {
    type: 'notWinning',
    formItems: [
      {
        label: "背景图",
        name: "backgroundImage",
        key: "style",
        stamp: 'singleImage',
        defaultValue: '/web_base_assets/scan/award_bg_default.png',
        help: "推荐尺寸750*1200,图片大小500kb以内"
      },
      {
        label: "背景颜色",
        name: "backgroundColor",
        key: "style",
        defaultValue: '#FF9501',
        type: "color",
        stamp: 'input'
      },
      {
        label: "图标",
        name: "icon",
        key: "params",
        stamp: 'singleImage',
        defaultValue: '/web_base_assets/scan/notWinning.png',
        help: "推荐尺寸750*1200,图片大小500kb以内"
      },
      {
        label: "未中奖文案",
        name: "copyWriting",
        defaultValue: '很遗憾,您没有中奖请再接再励',
        key: "params",
        maxlength:16,
        type:'text',
        stamp: 'input',
        help:'最多可输入16个字'
      },
      {
        label: "未中奖标题字颜色",
        name: "titleColor",
        defaultValue: '#ff3600',
        key: "style",
        type: "color",
        stamp: 'input'
      },
      {
        label: "未中奖文案字颜色",
        name: "textColor",
        defaultValue: '#E81425',
        key: "style",
        type: "color",
        stamp: 'input'
      },
      {
        label: "显示控制",
        name: "rankingKey",
        type: "text",
        stamp: 'checkbox',
        key: "params",
        help:'勾选需要显示的字段',
        options: [
          { label: '红包排行榜', value: 'red' },
          { label: '积分排行榜', value: 'point' },
        ],
      },
      {
        label: "显示控制",
        name: "btnKey",
        type: "text",
        stamp: 'checkbox',
        key: "params",
        help:'勾选需要显示的字段',
        options: [
          { label: '云店商城', value: 'cloud' },
          { label: '会员中心', value: 'center' },
        ],
      },
    ]
  },
  {
    type: 'repeatAward',
    formItems: [
      {
        label: "背景图",
        name: "backgroundImage",
        key: "style",
        stamp: 'singleImage',
        defaultValue: '/web_base_assets/scan/award_bg_default.png',
        help: "推荐尺寸750*1200,图片大小500kb以内"
      },
      {
        label: "背景颜色",
        name: "backgroundColor",
        key: "style",
        defaultValue: '#FF9501',
        type: "color",
        stamp: 'input'
      },
      {
        label: "图标",
        name: "icon",
        key: "params",
        stamp: 'singleImage',
        defaultValue: '/web_base_assets/scan/is_recovery_default.png',
        help: "推荐尺寸750*1200,图片大小500kb以内"
      },
      {
        label: "标题字颜色",
        name: "titleColor",
        defaultValue: '#ff3600',
        key: "style",
        type: "color",
        stamp: 'input'
      },
      {
        label: "文案字颜色",
        name: "textColor",
        defaultValue: '#E81425',
        key: "style",
        type: "color",
        stamp: 'input'
      },
      {
        label: "显示控制",
        name: "rankingKey",
        type: "text",
        stamp: 'checkbox',
        key: "params",
        help:'勾选需要显示的字段',
        options: [
          { label: '红包排行榜', value: 'red' },
          { label: '积分排行榜', value: 'point' },
        ],
      },
      {
        label: "显示控制",
        name: "btnKey",
        type: "text",
        stamp: 'checkbox',
        key: "params",
        help:'勾选需要显示的字段',
        options: [
          { label: '云店商城', value: 'cloud' },
          { label: '会员中心', value: 'center' },
        ],
      },
    ]
  }

]